import { cn } from '../cn';
import { Icon } from './Icon';

import type { IconName } from '../icons';
import type { ButtonHTMLAttributes } from 'react';

export interface IconButtonProps extends Omit<ButtonHTMLAttributes<HTMLButtonElement>, 'type' | 'children'> {
  name: IconName;
  size?: 'md' | 'sm' | undefined;
  variant?: 'ghost' | 'primary' | undefined;
  /** Required: an icon-only button has no visible label. */
  'aria-label': string;
  type?: 'button' | 'submit' | undefined;
}

const VARIANT = {
  ghost:
    'bg-transparent text-content-default hover:bg-surface-action-default-hover active:bg-surface-action-default-active',
  primary:
    'bg-surface-action-primary-default text-content-onactioninversed hover:bg-surface-action-primary-hover active:bg-surface-action-primary-active',
} as const;

export function IconButton({
  name,
  size = 'md',
  variant = 'ghost',
  type = 'button',
  className,
  ...rest
}: IconButtonProps) {
  return (
    <button
      type={type}
      className={cn(
        'inline-flex shrink-0 cursor-pointer items-center justify-center rounded-full transition-colors duration-150',
        'disabled:cursor-not-allowed disabled:bg-surface-action-default-disabled disabled:text-content-disabled',
        size === 'md' ? 'size-9' : 'size-7',
        VARIANT[variant],
        className,
      )}
      {...rest}
    >
      <Icon name={name} size={size === 'md' ? 18 : 16} />
    </button>
  );
}
